import React, { useState } from 'react'

const BusinessTableHeader = ({ businessData, setBusinessData }) => {
    const [state, setState] = useState({
        name: false,
        bId: false,
        mode: false,
        date: false,
        product: false
    })
    const handleSort = (type) => {
        let data = [...businessData]
        if (type === "name") {
            if (state.name) {
                data.sort((a, b) => {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) {
                        return 1
                    }
                    else {
                        return -1
                    }
                })
                setState({
                    ...state,
                    name: false
                })
            } else {
                data.sort((a, b) => {
                    if (a.name.toLowerCase() > b.name.toLowerCase()) {
                        return 1
                    }
                    else {
                        return -1
                    }
                })
                setState({
                    ...state,
                    name: true
                })
            }
        }
        if (type === "mode") {
            if (state.mode) {
                data.sort((a, b) => {
                    if (a.mode.toLowerCase() < b.mode.toLowerCase()) {
                        return 1
                    }
                    else {
                        return -1
                    }
                })
                setState({
                    ...state,
                    mode: false
                })
            } else {
                data.sort((a, b) => {
                    if (a.mode.toLowerCase() > b.mode.toLowerCase()) {
                        return 1
                    }
                    else {
                        return -1
                    }
                })
                setState({
                    ...state,
                    mode: true
                })
            }

        }
        if (type === "product") {
            if (state.product) {
                data.sort((a, b) => {
                    if (a.product > b.product) {
                        return 1
                    }
                    else {
                        return -1
                    }
                })
                setState({
                    ...state,
                    product: false
                })
            } else {
                data.sort((a, b) => {
                    if (a.product < b.product) {
                        return 1
                    }
                    else {
                        return -1
                    }
                })
                setState({
                    ...state,
                    product: true
                })
            }
        }

        setBusinessData(data)
    }
    return (
        <tr>
            <th width="150"></th>
            <th onClick={() => handleSort('name')} className='cursor-pointer'>Name</th>
            <th onClick={() => handleSort('mode')} className='cursor-pointer'>Mode</th>
            <th onClick={() => handleSort('product')} className='cursor-pointer'># Products</th>
            <th></th>
        </tr>
    )
}

export default BusinessTableHeader